module.exports = __webpack_public_path__ + "img/mac-and-cheese.3b57740d.jpg";